var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"align":"center"}},[_c('v-col',{attrs:{"cols":"1"}},[_c('v-checkbox',{staticClass:"ma-0 pa-0",attrs:{"dense":""},model:{value:(_vm.innerVal),callback:function ($$v) {_vm.innerVal=$$v},expression:"innerVal"}})],1),_c('v-col',{staticClass:"mb-5",attrs:{"cols":"10"}},[_c('span',{class:[
        'clickable', 
        'grey--text',
        { 'primary--text': _vm.innerVal }
      ],on:{"click":function($event){_vm.innerVal = !_vm.innerVal}}},[_vm._v(" "+_vm._s(_vm.label)+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }